import { useMutation } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { defineMessages, useIntl } from "react-intl";

import { useApi } from "@/hooks";
import toast from "@/toast";

import { updateStatusCache } from "../utils";

const messages = defineMessages({
  deletedTruth: {
    id: "status.error.deletedTruth",
    defaultMessage: "This Truth has been deleted and is no longer available.",
  },
});

function useDeleteVoteOnStatus() {
  const intl = useIntl();
  const api = useApi();

  return useMutation({
    mutationFn: (statusId: string) =>
      api.delete(`/api/v1/statuses/${statusId}/reaction`),
    async onMutate(statusId) {
      const [prevStatus] = updateStatusCache(statusId, (prevStatus) => ({
        reaction: null,
        upvotes_count:
          prevStatus.reaction === "upvote"
            ? prevStatus.upvotes_count - 1
            : prevStatus.upvotes_count,
        downvotes_count:
          prevStatus.reaction === "downvote"
            ? prevStatus.downvotes_count - 1
            : prevStatus.downvotes_count,
      }));

      return { prevStatus };
    },
    onError(error: AxiosError, statusId, context) {
      if (error.response?.status === 404) {
        toast.error(intl.formatMessage(messages.deletedTruth));
      }
      // Return status back to its original state
      if (context) {
        updateStatusCache(statusId, () => context.prevStatus!);
      }
    },
  });
}

export { useDeleteVoteOnStatus };
